import Swiper, { Navigation, Pagination } from "swiper";

export default class ComponentTituloSubtituloAccordeonSliderFotos {
    constructor() {

        this.sections = document.querySelector('.component-titulo_subtitulo_accordeon_slider_fotos')
        this.accordeons = this.sections.querySelectorAll('.accordeon')
        this.accordeonsBtns = this.sections.querySelectorAll('.accordeon .titulo')

        this.sliders = this.sections.querySelectorAll('.swiper--component-titulo_subtitulo_accordeon_slider_fotos')

        this.ready();
    }

    ready() {

        this.accordeonsBtns.forEach(accordeon => {
            accordeon.addEventListener('click', () => {
                this.accordeons.forEach(el => {
                    el.classList.remove('active')
                })
                this.sliders.forEach(slider => {
                    slider.classList.remove('active')
                })
                accordeon.parentElement.classList.add('active')
                document.querySelector('.'+accordeon.dataset.slider).classList.add('active')
            })
        })

        if(this.sliders) {
            this.sliders.forEach((current, index) => {

                const sliderCurrent = document.querySelector('.swiper-accordeon-'+index)
                const swiper = new Swiper(sliderCurrent, {
                    modules: [Navigation, Pagination],
                    grabCursor: true,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: document.querySelector('.swiper-accordeon-'+index+' .slider-button-next--cp-nav'),
                        prevEl: document.querySelector('.swiper-accordeon-'+index+' .slider-button-prev--cp-nav')
                    },
                    pagination: {
                        el: document.querySelector('.swiper-accordeon-'+index+' .slider-pagination--cp-nav'),
                        clickable: true,
                    },
                    slidesPerView: 1,
                })
            })
        }
        
    }
}